import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Common Page
import { CommonPageComponent } from './digigov/dg_core/common-page/common-page.component';

//Main Component
import { MainComponent } from './digigov/dg_core/main/main.component';

import { PreLoginComponent } from './digigov/dg_core/pre-login/pre-login.component';
import { UnauthorizedPageComponent } from './digigov/dg_core/unauthorized-page/unauthorized-page.component';
import { UserActivationComponent } from './digigov/dg_core/user-activation/user-activation.component';
import { AuthGuardService } from './digigov/guards/auth-guard.service';
import { PrivilegeGuard } from './digigov/guards/privilege.guard';
import { DgFileWindowComponent } from './digigov/dg_core/dg-file-window/dg-file-window.component';
import { OnlyOfficeWindowComponent } from './digigov/dg_core/dg-file-onlyoffice/only-office-window/only-office-window.component';
import { DgFileUploadTestComponent } from './digigov/dg_components_test/dg-file-upload-test/dg-file-upload-test.component';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [AuthGuardService],
    component: PreLoginComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./digigov/dg_core/pre-login/dg_prelogin.module').then(
            (m) => m.DgPreloginModule
          ),
      },
      // Default Page
      { path: '**', component: CommonPageComponent },
    ],
  },
  {
    path: 'file-window',
    component: DgFileWindowComponent,
  },
  {
    path: 'onlyoffice-window',
    component: OnlyOfficeWindowComponent,
  },
  {
    path: 'onlyoffice-window-test',
    component: DgFileUploadTestComponent,
  },

  {
    path: 'useractivation/:id',
    component: UserActivationComponent,
    pathMatch: 'full',
  },
  // {
  //   path: 'cfms',
  //   loadChildren: () =>
  //     import('./cfms/cfms.module').then((m) => m.CfmsModule),
  // },

//  {
//     path: '',
//     component: MainComponent,
//      children: [
     
//],
// 	  },
  // {
  //   path: 'app',
  //   canActivate: [AuthGuardService],
  //   canActivateChild: [PrivilegeGuard],
  //   loadChildren: () =>
  //     import(
  //       './digigov/dg_components_test/applications/application.module'
  //     ).then((m) => m.ApplicationModule),
  // },
  {
    path: 'unauthorized',
    component: UnauthorizedPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'payment-gateway',
    loadChildren: () =>
      import('./digigov/dg_core/payment-gatway/payment-gatway.module').then(
        (m) => m?.PaymentGatewayModule
      ),
  },

  {
    path: '',
    canActivate: [AuthGuardService],
    canActivateChild: [PrivilegeGuard],
    component: MainComponent,
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },

      {
        path: 'main',

        //Application core rouing
        /*
        loadChildren: () =>
          import('./application-core-routing.module').then(
            (m) => m.AppCoreRoutingModule
          ),
          */
        //Digigov core routing
        loadChildren: () =>
          import('./digigov/dg_core/dg_core.module').then(
            (m) => m.DgCoreModule
          ),
      },
      {
        path: 'cfms',
        loadChildren: () =>
          import('./cfms/cfms.module').then((m) => m.CfmsModule),
      },
      {
        path: 'test',
        loadChildren: () =>
          import('./digigov/dg_components_test/dg_component_test.module').then(
            (m) => m.DgComponentTestModule
          ),
      },

      // Default Page
      { path: '**', redirectTo: '/main' },
    ],
  },

  { path: '**', redirectTo: 'main/**' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
